export const sectionIds = ["work", "about", "resume", "contact"];
